export default class BomModel {
  constructor () {
    this.품번 = null
    this.품명 = null
    this.수량 = null
    this.상위품번 = null
    this.최상위품번 = null
  }
}
